import adminApiClient from './adminApiClient';

const adminBlockSlotService = {

  // Chatbot block defs

  getChatbotBlockDefs: () =>
    adminApiClient.get('/api/admin/chatbot-block-defs'),

  createChatbotBlockDef: (def) =>
    adminApiClient.post('/api/admin/chatbot-block-defs', def),

  updateChatbotBlockDef: (id, def) =>
    adminApiClient.put(`/api/admin/chatbot-block-defs/${id}`, def),

  deleteChatbotBlockDef: (id) =>
    adminApiClient.delete(`/api/admin/chatbot-block-defs/${id}`),

  // CMMS slot pack defs

  getCmmsSlotPackDefs: (resourceType) => {
    const url = resourceType
      ? `/api/admin/cmms-slot-pack-defs?resourceType=${resourceType}`
      : '/api/admin/cmms-slot-pack-defs';
    return adminApiClient.get(url);
  },

  createCmmsSlotPackDef: (def) =>
    adminApiClient.post('/api/admin/cmms-slot-pack-defs', def),

  updateCmmsSlotPackDef: (id, def) =>
    adminApiClient.put(`/api/admin/cmms-slot-pack-defs/${id}`, def),

  deleteCmmsSlotPackDef: (id) =>
    adminApiClient.delete(`/api/admin/cmms-slot-pack-defs/${id}`),
};

export default adminBlockSlotService;
